export default __webpack_public_path__ + "static/media/Voorbeeld_LuFo_HiRes-klein.cc0abcfa.jpg";